import React, {useState} from "react";
import {HashRouter, Link, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import style from './Sections.scss'
import {actionIcons} from "./schema"
import Modal from 'react-modal'


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '25px 45px',
        borderRadius: '12px',
        textAlign: 'center'
    }
};

class Sections extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            section: '',
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.yesModal = this.yesModal.bind(this);


    }

    openModal(e) {
        this.setState({modalIsOpen: true, section: e});
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    yesModal() {
        this.props.deleteSection(this.state.section);
        this.setState({modalIsOpen: false});
    }

    render() {

        const {fields, addNewSection, duplicateSection, deleteSection, activeSection} = this.props;
        const section = this.props.match.params.sectionId;
        return (<HashRouter>

            <div className={style.wrap}>

                <div className={style.lftsec} >

                <ul className={style.container} >
                    {Object.keys(fields).filter(e => fields[e].extra.status && fields[e].extra.status !== -1).map((e, i) => { // -1 stands for temp

                        return (
                            <li
                                key={e}
                                className={`${style.section} ${e === section ? style.active : ''} ${(fields[e].extra.error?style.hasError:'')}`}
                            >
                                <Link to={`/section/${e}`}>{fields[e].extra.name} </Link>
                                {/* console.log(fields[e].extra.name) */}
                                 <div className={style.actions} >

                                         <span onClick={() => {
                                                addNewSection('edit', fields[e].extra)
                                           }}>
                                            <img src={actionIcons['edit'].icon}/>
                                         </span>


                                     { /* (fields[e].extra.key === 'billing' || fields[e].extra.key === 'shipping' || fields[e].extra.key === 'order' || fields[e].extra.key === 'account') ?

                                         <span className={style.inactive} >
                                            <img src={actionIcons['edit'].icon}/>
                                        </span>

                                         :
                                         <span onClick={() => {
                                             addNewSection('edit', fields[e].extra)
                                         }}>
                                            <img src={actionIcons['edit'].icon}/>
                                        </span>
                                    */ }


                                     <span onClick={() => {
                                                duplicateSection(e)
                                            }}>
                                            <img src={actionIcons['copy'].icon}/>
                                        </span>
                                        { /* <span onClick={() => { */ }
                                        { /* deleteSection(e) */ }
                                        { /*    }}> */ }
                                        { /*    <img src={actionIcons['delete'].icon}/> */ }
                                        { /* </span> */ }

                                     { (fields[e].extra.key === 'billing' || fields[e].extra.key === 'shipping' || fields[e].extra.key === 'order' || fields[e].extra.key === 'account') ?

                                         <span className={style.inactive} >
                                            <img src={actionIcons['delete'].icon}/>
                                         </span>

                                         :
                                         <span onClick={() => { this.openModal(e) }}>
                                            <img src={actionIcons['delete'].icon}/>
                                         </span>
                                     }


                                     <Modal
                                         isOpen={this.state.modalIsOpen}
                                         onAfterOpen={this.afterOpenModal}
                                         onRequestClose={this.closeModal}
                                         style = {customStyles}
                                         contentLabel="Delete"
                                     >
                                         <h2 ref={subtitle => this.subtitle = subtitle} > Delete</h2>
                                         <div className={style.mPopUp} >{wp.i18n.__('Are you sure, you want to delete this item ?')} </div>
                                         <button className={style.buttonNo} onClick={this.closeModal}> {wp.i18n.__('Cancel')} </button>
                                         <button className={style.buttonYes} onClick={this.yesModal}> {wp.i18n.__('Yes, please delete')} </button>
                                         {/* <button className={style.buttonYes} className={e} onClick={this.yesModal}> {wp.i18n.__('Yes')} </button> */ }
                                     </Modal>
                                </div>
                            </li>
                        )
                    })}

                </ul>

                </div>
                <div className={style.rhtsec} >

                <button className={style.buttonNew} onClick={this.props.addNewSection}>
                    {wp.i18n.__('Add new section')}
                </button>

                </div>

            </div>

        </HashRouter>)
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        fields: typeof state.fields.data !== "undefined" ? state.fields.data : []
    }
}
export default connect(mapStateToProps)((Sections))
